module.exports = __webpack_public_path__ + "static/img/sort3.8d431e0f.png";